import React from 'react';
import { COLORS } from '@app/src/ui';
import { Icon } from '@app/src/common/Icon';
import {
  Label,
  Hidden,
  Mask,
  Text,
  MaskCheckbox
} from './styled';

interface Props {
  name: string;
  handleChange?: Function;
  handleChangeInput?: Function;
  value: string;
  checked?: boolean;
  colorActive?: string;
  text?: string;
  disabled?: string;
  children?: React.ReactNode;
  contentLeft?: boolean;
  className?: string;
  handleClick?: Function;
  maskCheckbox?: boolean;
}

export const RadioInput: React.FC<Props> = ({
  name,
  handleChange,
  handleChangeInput,
  value,
  checked,
  colorActive,
  contentLeft,
  disabled,
  children,
  className,
  handleClick,
  text,
  maskCheckbox
}) => {
  const handleChangeProp = (e) => {
    handleChange && handleChange(e.target.value);
    handleChangeInput && handleChangeInput(e);
  }

  return (
  <Label
    onClick={e => handleClick && handleClick(e)}
    checked={checked}
    colorActive={colorActive}
    className={className}
    disabled={disabled}>
    <Hidden
      checked={checked}
      type="radio"
      name={name}
      value={value}
      onChange={handleChangeProp}
    />
    {
      contentLeft ?
        <React.Fragment>
          { text ? <Text>{text}</Text> : children }
          {
            maskCheckbox ?
              <MaskCheckbox>
                <Icon data-name="icon-check" fill={colorActive} width="16" height="16" />
              </MaskCheckbox>
              :
              <Mask />
          }
        </React.Fragment>
      :
        <React.Fragment>
          {
            maskCheckbox ?
              <MaskCheckbox>
                <Icon data-name="icon-check" fill={colorActive} width="16" height="16" />
              </MaskCheckbox>
              :
              <Mask />
          }
          { text ? <Text>{text}</Text> : children}
        </React.Fragment>
    }
  </Label>
)};

RadioInput.defaultProps = {
  colorActive: COLORS.GRAY_DARK
}
